import React, { useEffect, useState } from 'react'
import { Modal, Button, Form } from 'react-bootstrap'
import Select from 'react-select'
import { toast } from 'react-toastify'

import colaboradoresService from '../../services/colaboradores.service'
import dashboardService from '../../services/dashboard.service'

export default function TransferirResponsavelModal({ show, onHide, plano, tipoPlano, onSuccess }) {
  const [colaboradores, setColaboradores] = useState([])
  const [novoColaborador, setNovoColaborador] = useState(null)
  const [salvando, setSalvando] = useState(false)
  const [carregando, setCarregando] = useState(false)

  useEffect(() => {
    if (!show) return

    setNovoColaborador(null)
    setCarregando(true)
    colaboradoresService
      .getAllColaboradores()
      .then(({ data }) => {
        setColaboradores(
          (data || [])
            .filter((c) => c.ativo)
            .map(({ nome, id }) => ({ label: nome, value: id }))
        )
      })
      .catch(() => toast.error('Erro ao carregar colaboradores.'))
      .finally(() => setCarregando(false))
  }, [show])

  const opcoes = colaboradores.filter((c) => c.value !== plano?.colaboradorResponsavelId)
  const responsavelAtual = colaboradores.find((c) => c.value === plano?.colaboradorResponsavelId)

  const handleConfirmar = async () => {
    if (!plano?.id || !novoColaborador?.value) {
      toast.error('Selecione o novo colaborador responsável.')
      return
    }

    setSalvando(true)
    try {
      await dashboardService.transferirResponsavel({
        planoId: plano.id,
        tipoPlano,
        novoColaboradorId: novoColaborador.value,
      })
      toast.success('Responsável transferido com sucesso.')
      onHide()
      if (onSuccess) await onSuccess()
    } catch (error) {
      const mensagem =
        (typeof error?.response?.data?.errors === 'string' && error.response.data.errors) ||
        error?.response?.data?.mensagemErro ||
        error?.response?.data?.message ||
        'Erro ao transferir responsável.'
      toast.error(mensagem)
    } finally {
      setSalvando(false)
    }
  }

  return (
    <Modal show={show} onHide={salvando ? undefined : onHide} centered>
      <Modal.Header closeButton={!salvando}>
        <Modal.Title>Transferir responsável</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {plano && (
          <>
            <p className='mb-1'>
              <b>Plano:</b> {plano.numeroPlano} ({tipoPlano})
            </p>
            <p className='mb-1 text-uppercase'>
              <b>Paciente:</b> {plano.dependente?.nome || plano.paciente?.nome}
            </p>
            <p className='mb-3 text-uppercase'>
              <b>Responsável atual:</b>{' '}
              {plano.nomeColaboradorResponsavel || responsavelAtual?.label || '-'}
            </p>
            <Form.Group>
              <Form.Label>Novo colaborador (ativos)</Form.Label>
              <Select
                placeholder={carregando ? 'Carregando...' : 'Selecione o colaborador'}
                options={opcoes}
                value={novoColaborador}
                onChange={setNovoColaborador}
                noOptionsMessage={() => 'Nenhum colaborador ativo'}
                isDisabled={salvando || carregando}
              />
            </Form.Group>
          </>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant='secondary' onClick={onHide} disabled={salvando}>
          Cancelar
        </Button>
        <Button variant='primary' onClick={handleConfirmar} disabled={!novoColaborador || salvando || carregando}>
          {salvando ? 'Transferindo...' : 'Confirmar'}
        </Button>
      </Modal.Footer>
    </Modal>
  )
}
